<!-- <app-column-header [headerData]="headerData"></app-column-header> -->
<!-- <div class="columnHeader">
  <h3 class="smalltitle">Dashboard</h3>
  <div class="columnHeaderMultipleBtn">
    <button class="addModule" title="Add New Menu" (click)="addModule()" *ngIf=" headerData.button.show">
      Add Module
      <svg>
        <use [attr.xlink:href]="srcPath.addModule"></use>
      </svg>
    </button>
    <button class="addModule" title="Add New Menu" (click)="addNewMenu()" *ngIf=" headerData.button.show">
      Add New Menu
      <svg>
        <use [attr.xlink:href]="srcPath.addModule"></use>
      </svg>
    </button>
    <button class="addModule" title="Add New Page" (click)="addNewPage(1)" *ngIf=" headerData.button.show">
      Add New Page
      <svg>
        <use [attr.xlink:href]="srcPath.addModule"></use>
      </svg>
    </button>

  </div>
</div> -->

<div class="adtabcontent">
  <div class="adtabtitle">
    <hr>
    <div class="spriteBtns">
      <button title="Add New Menu" (click)="addModule()" *ngIf=" headerData.button.show">
        Add Module
      </button>
      <button title="Add New Menu" (click)="addNewMenu()" *ngIf=" headerData.button.show">
        Add Menu
      </button>
      <button title="Add New Page" (click)="addNewPage(1)" *ngIf=" headerData.button.show">
        Add New Page
      </button>
    </div>
  </div>
  <div class="adbcards">

    <div class="admcard" *ngFor="let data1 of menuTemplate">
      <div class="admhead">
        <span>
          <svg>
            <use [attr.xlink:href]="adminMenuIcon+'adcustomers'"></use>
          </svg>
        </span>
        <a class="cursrponts">
          {{data1.gstibo_menu_name}}
        </a>
        <button (click)="backBtnClick(data1)">
          <svg>
            <use [attr.xlink:href]="adminMenuIcon+'adback'"></use>
          </svg>
        </button>
      </div>
      <!-- ------ content1 -->
      <div class="admcontent" *ngIf="(selectedParentMenu == 0 || data1.gstibo_menu_id != selectedParentMenu)">
        <ul class="admitemlist">
          <li *ngFor="let data of data1.child">
            <span (click)="openPagesUnderMenu(data1,data.gstibo_menu_id)">
              <svg>
                <use [attr.xlink:href]="srcPath.menuIconPath+data.gstibo_menu_icon"></use>
              </svg>
            </span>
            <a (click)="openPagesUnderMenu(data1,data.gstibo_menu_id)" class="cursrponts">
              {{data.gstibo_menu_name}}
            </a>
            <div class="actions">
              <button class="edit" (click)="editSubMenu(data)">
                <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
                </svg>
              </button>
              <button class="delete" (click)="deleteMenu(data.gstibo_menu_id)"
                *ngIf="canCreatePage==superAdminStatus.yes">
                <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
                </svg>
              </button>

            </div>
          </li>

        </ul>
      </div>
      <!-- ------ content1 -->
      <!-- ------ content2 -->
      <div class="admcontent" *ngIf="selectedParentMenu == data1.gstibo_menu_id ">
        <ul class="admitemlist">
          <li *ngFor="let pageData of pages_under_menu_group">
            <span (click)="viewPage(pageData)">
              <svg>
                <use [attr.xlink:href]="srcPath.menuIconPath+pageData.gstibo_icon"></use>
              </svg>
            </span>
            <a (click)="viewPage(pageData)" class="cursrponts">
              {{pageData.gstibo_menu_name}}
            </a>
            <div class="actions">
              <button class="edit" (click)="editPage(pageData)">
                <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
                </svg>
              </button>
              <button class="delete" (click)="deletePage(pageData.gstibo_page_id)"
                *ngIf="canCreatePage==superAdminStatus.yes">
                <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
                </svg>
              </button>

            </div>
          </li>

        </ul>
      </div>
      <!-- ------ content2 -->
    </div>

  </div>

</div>
<!-- ------------------------- -->
<!-- 
<div class="row adminrow">
  <div class="col-1-of-3" *ngFor="let data1 of menuTemplate">
    <div class="cards admins">
      <div class="cards_head">
        <h4>{{data1.gstibo_menu_name}}</h4>
        <div class="bttns" style="grid-template-columns: repeat(1, 1fr) !important; ">
          <button class="bttn back09" (click)="backBtnClick(data1)">
            <svg>
              <use [attr.xlink:href]="srcPath.previousArrowIcon"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="cards_body" *ngIf="(selectedParentMenu == 0 || data1.gstibo_menu_id != selectedParentMenu)">
        <div class="icon_group" *ngFor="let data of data1.child">
          <figure class="{{(data.gstibo_menu_style =='grn-1' ? 'back06' : data.gstibo_menu_style)}}"
            (click)="openPagesUnderMenu(data1,data.gstibo_menu_id)">
            <svg class="icon">
              <use [attr.xlink:href]="srcPath.menuIconPath+data.gstibo_menu_icon"></use>
            </svg>
          </figure>
          <figcaption (click)="viewPage(data)">
            {{data.gstibo_menu_name}}</figcaption>
          <div class="editApp">
            <a class=" cursor-pointer)" (click)="editSubMenu(data)">Edit</a>
            <a class="cursor-pointer" (click)="deleteMenu(data.gstibo_menu_id)"
              *ngIf="canCreatePage==superAdminStatus.yes">Delete</a>
          </div>
        </div>
      </div>
      <div class="cards_body" *ngIf="selectedParentMenu == data1.gstibo_menu_id ">
        <div class="icon_group" *ngFor="let pageData of pages_under_menu_group">
          <figure class="{{pageData.gstibo_menu_icon}}" (click)="viewPage(pageData)">
            <svg class="icon">
              <use [attr.xlink:href]="srcPath.menuIconPath+pageData.gstibo_icon"></use>
            </svg>
          </figure>
          <figcaption (click)="viewPage(pageData)">
            {{pageData.gstibo_menu_name}}</figcaption>
          <div class="editApp">
            <a class="cursor-pointer" (click)="editPage(pageData)">Edit</a>
            <a class="cursor-pointer" (click)="deletePage(pageData.gstibo_page_id)"
              *ngIf="canCreatePage==superAdminStatus.yes">Delete</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div> -->